module.exports = __webpack_public_path__ + "static/proximity-a712791fb8dc83d9037f8fde9485af31.png";